import * as ko from "knockout";
import { isNullOrWhitespace } from "./string";

/**
 * Converts a period-segmented string into a list of CSS classes.
 *
 * @param {string|KnockoutObservable<string>} segments
 *     A string or observable containing the segments to be converted.
 * @param {string|KnockoutObservable<string>} currentCss
 *     The current CSS class string. If provided, will be prefixed to the result.
 * @param {string = ""} prefix
 *     The prefix to use for each resulting CSS class.
 * @return {string}
 *     A space-separated list of classes representing the given segments.
 *
 * @example
 *     stateToCss("good.right", "myClass", "wifState") -> "myClass wifStateGood wifStateRight"
 */
export default function segmentToClasses(segments: string|ko.Observable<string>, currentCss?: string|ko.Observable<string>, prefix: string = ""): string { // tslint:disable-line: no-default-export // TODO: remove in v8
    const cssItems: string[] = [];

    for (const stateItem of (ko.unwrap(segments) || "").split(".")) {
        if (!isNullOrWhitespace(stateItem)) {
            cssItems.push(`${prefix}${stateItem[0].toUpperCase()}${stateItem.substring(1)}`);
        }
    }

    const cssString = cssItems.join(" ");
    const currentCssValue = ko.unwrap(currentCss);
    return (!isNullOrWhitespace(currentCssValue) ? `${currentCssValue} ${cssString}` : cssString);
};



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/util/segmentToClasses.ts